import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=27c0ec36&scoped=true"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"
import style0 from "./MyPlan.vue?vue&type=style&index=0&id=27c0ec36&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0ec36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c0ec36')) {
      api.createRecord('27c0ec36', component.options)
    } else {
      api.reload('27c0ec36', component.options)
    }
    module.hot.accept("./MyPlan.vue?vue&type=template&id=27c0ec36&scoped=true", function () {
      api.rerender('27c0ec36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PrincipalOverviewWork/components/MyPlan.vue"
export default component.exports